import { use } from 'react';

import { TableViewContext, type TableViewContextValue } from './TableViewContext';

/**
 * Frozen fallback for when no <TableViewProvider> is present — MapView also renders
 * on the SAVI route and in tests with no provider, where Table View is unavailable.
 * All actions are no-ops and the table stays closed, so the map behaves as before.
 */
const NOOP_VALUE: TableViewContextValue = Object.freeze({
    layout: 'closed',
    isOpen: false,
    open: () => {},
    close: () => {},
    maximise: () => {},
    restoreSplit: () => {},
    toggle: () => {},
});

/** Reads the Network Overview table's layout state. Returns a no-op value outside a provider. */
export function useTableView(): TableViewContextValue {
    return use(TableViewContext) ?? NOOP_VALUE;
}
